namespace BlockPuzzle {
    export enum PowerupType {
        BOMB = 'Bomb',
        LIGHTNING = 'Lightning'
    }
}